/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_rk_114_107 as Componente_rk_114_107,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_nk_110_107(e) {
  let t = (0, ReactCompiler.c)(4),
    { proyectos: n } = e,
    r;
  t[0] === n
    ? (r = t[1])
    : ((r = n.map(Componente_rk_114_107)), (t[0] = n), (t[1] = r));
  let i;
  return (
    t[2] === r
      ? (i = t[3])
      : ((i = (
          <ul className={`animar-cascada flex flex-col gap-1.5`} children={r} />
        )),
        (t[2] = r),
        (t[3] = i)),
    i
  );
}
